import React, { useState, useEffect } from "react";

function SearchResult({ data, type, filter, query }) {
  const [filteredData, setFilteredData] = useState([]);

  useEffect(() => {
    if (!data) return;

    const normalizedData = data.map((item) => ({
      ...item,
      image: item.avatar
        ? `${item.avatar}`
        : "/default-avatar.png",
    }));
 
    let result = normalizedData;

    if (type === "users" && query.trim() !== "") {
      const q = query.toLowerCase();

      result = normalizedData.filter((item) => {
        switch (filter) {
          case "name":
            return item.name?.toLowerCase().includes(q);
          case "profession":
            return item.profession?.toLowerCase().includes(q);
          case "email":
            return item.email?.toLowerCase().includes(q);
          case "phone_number":
            return item.phone_number?.toLowerCase().includes(q);
          default:
            return (
              item.name?.toLowerCase().includes(q) ||
              item.profession?.toLowerCase().includes(q) ||
              item.email?.toLowerCase().includes(q) ||
              item.phone_number?.toLowerCase().includes(q)
            );
        }
      });
    }

    setFilteredData(result);
  }, [data, filter, query, type]);

  if (!filteredData || filteredData.length === 0) return null;

  return (
    <div className="search-result">
      <p className="search-result-title">Search Results</p>
      <div className="row">
        {filteredData.map((item) => (
          <div className="col-md-4 mb-4" key={item.id}>
            <div className="search-result-card">
              <div className="search-result-card-wrap">
                {type === "users" && (
                  <>
                    <img src={item.image} alt={item.name} />
                    <div className="result-name">
                      <span>{item.name}</span> <br />
                      <span>{item.profession || "N/A"}</span>
                    </div>
                  </>
                )}
              </div>
              <a href={`/searchprofile/${item.id}`}>View Details</a>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default SearchResult;
